import styled from 'styled-components'
import { Button } from 'antd'
import {
  COLORS,
  SPACING,
  BORDER_RADIUS,
  TYPOGRAPHY,
  TRANSITIONS,
  MEDIA,
  FONT_WEIGHT,
} from '../../../../styles/theme'

export const ChatWindowContainer = styled.div<{ $isVisible: boolean; $isMinimized: boolean }>`
  position: fixed;
  bottom: ${(props) => (props.$isMinimized ? '20px' : '20px')};
  right: 20px;
  width: ${(props) => (props.$isMinimized ? '300px' : '350px')};
  height: ${(props) => (props.$isMinimized ? '60px' : '500px')};
  z-index: 1000;
  background: var(--color-bg-elevated);
  border-radius: ${BORDER_RADIUS.sm};
  box-shadow: var(--shadow-dropdown);
  display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
  flex-direction: column;
  transition: ${TRANSITIONS.smooth};
  overflow: hidden;

  ${MEDIA.mobile} {
    right: 10px;
    left: 10px;
    width: auto;
    max-width: calc(100vw - 20px);
    bottom: 10px;
    height: ${(props) => (props.$isMinimized ? '60px' : 'calc(100dvh - 84px)')};
  }
`

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.md} ${SPACING.lg};
  background: var(--color-bg-secondary);
  border-bottom: 1px solid var(--color-border);
  cursor: pointer;
  user-select: none;

  &:hover {
    background: var(--color-bg-hover);
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
`

export const HeaderTitleWrapper = styled.div`
  flex: 1;
  min-width: 0;
`

export const ChatContainerWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

export const HeaderTitle = styled.div`
  font-weight: ${FONT_WEIGHT.semibold};
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HeaderSubtitle = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 6px;
`

export const FeedbackBadge = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: ${COLORS.primary};
  background: color-mix(in srgb, ${COLORS.primary} 15%, transparent);
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs};
`

export const HeaderButton = styled(Button)`
  padding: ${SPACING.xs} !important;
  min-width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: var(--color-bg-hover) !important;
  }
`

export const ChatContent = styled.div<{ $isMinimized: boolean }>`
  display: ${(props) => (props.$isMinimized ? 'none' : 'flex')};
  flex-direction: column;
  height: 100%;
  flex: 1;
  overflow: hidden;

  /* Override ChatScope MessageInput styles */
  .cs-message-input {
    background: var(--color-bg-elevated) !important;
    border-top: 1px solid var(--color-border) !important;
  }

  .cs-message-input__content-editor-wrapper {
    background: var(--color-bg-elevated) !important;
  }

  .cs-message-input__content-editor {
    background: var(--color-bg-elevated) !important;
    color: var(--color-text-primary) !important;
  }

  .cs-message-input__content-editor[data-placeholder]:empty:before {
    color: var(--color-text-muted) !important;
  }
`
